export default __webpack_public_path__ + "static/birds-8dbdac6ce1512b6d03d5c924dcd6ce2f.jpg";